import {
    faEdit,
    faEraser,
    faFilter,
    faTrash,
    faUserTimes,
} from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    ExcluirContratosCampanhaController,
    ExcluirContratosController,
    ExcluirContratosPorGrupoController,
} from "../../../../Controllers/Cobranca/DistribuicaoCarteira/DistribuicaoCarteiraControllers";
import {
    IContrato,
    IListaGrupoContrato,
} from "../../../../Interfaces/Cobranca/Contrato/ContratoInterfaces";
import Swal from "sweetalert2";
import { ColumnDescription, ExpandRowProps } from "react-bootstrap-table-next";
import Table from "../../../../Components/Table";
import SpinnerComponent from "../../../../Components/Loding/Spinner";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import {
    ListarClassificacaoCobrancaController,
    RemoverClassificacaoManualController,
} from "../../../../Controllers/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaController";
import UnForm from "../../../../Components/Form";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import { SetStateAction, Dispatch } from "react";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";

const filtroDeTextoTable = textFilter({
    placeholder: "Filtro...",
});

interface ITableManualCliente {
    filterValueContratos: object[];
    ListarContratosDistribuidosPorGrupo: any;
    lstSelecionadosDistribuidos: IListaGrupoContrato | undefined;
    handleExcluirContratosEmMassa: () => void;
    ExcluirContratosEmMassaLoading: boolean;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    handleSubmitClassificacao: (
        idClassificacao: any,
        ID_CHAVE_ERP: any
    ) => void;
    setShow: Dispatch<SetStateAction<boolean>>;
    ListarContratosDistribuidos: any;
    ListarContratosNaoDistribuidos: any;
    setlstSelecionados: Dispatch<SetStateAction<IContrato[]>>;
    lstContratosDistribuidosPorGrupo: IListaGrupoContrato[];
    setlstSelecionadosDistribuidos: Dispatch<
        SetStateAction<IListaGrupoContrato | undefined>
    >;
}

function TableManualCliente(props: ITableManualCliente) {
    const tableColumns: Array<ColumnDescription<IContrato>> = [
        {
            headerAlign: "center",
            dataField: "ID_EMPRESA",
            text: "Empresa",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "ID_OBRA",
            text: "Obra",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "ID_VENDA",
            text: "Venda",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "DS_CLIENTE",
            text: "Cliente",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "DS_IDENTIFICADOR",
            text: "Quadra/Lote",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "",
            text: "Status Escritura",
            align: "center",
            filter: filtroDeTextoTable,
            formatter: (c, row) =>
                `${row.ST_ESCRITURA} / ${row.DS_STATUS_ESCRITURA}`,
        },
        {
            headerAlign: "center",
            dataField: "",
            text: "Status Cobrança",
            align: "center",
            filter: filtroDeTextoTable,
            formatter: (c, row) =>
                `${row.ST_COBRANCA} / ${row.DS_STATUS_COBRANCA}`,
        },
        {
            headerAlign: "center",
            dataField: "NR_PARCELAS_EM_ABERTO",
            text: "Qt. Parc Aberto",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "VL_UNIDADE",
            text: "Vlr. Venda",
            align: "center",
            formatter: (c) => formatMoneyReais(c),
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "VL_RECEBIDO_VGV",
            text: "Vlr. Recebido",
            align: "center",
            formatter: (c) => formatMoneyReais(c),
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "VL_PARCELAS_EM_ABERTO",
            text: "Vlr. Parcelas Aberto",
            align: "center",
            formatter: (c) => formatMoneyReais(c),
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "DS_CLASSIFICACAO_CONTRATO",
            text: "Classificação",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "NR_AGING",
            text: "Aging",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "NR_DIAS_ULTIMO_CASO",
            text: "Dias Últ. Caso",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            headerAlign: "center",
            dataField: "DS_RESULTADO_CONTATO",
            text: "Observação",
            align: "center",
            filter: filtroDeTextoTable,
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            headerFormatter: () => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="ver-info-tooltip">
                            Excluir Contratos Filtrados
                        </Tooltip>
                    }
                >
                    <button
                        className="btn btn-danger mb-4 mt-0"
                        onClick={() =>
                            Swal.fire({
                                title: `Deseja descartar ${
                                    props.filterValueContratos?.length
                                } contrato${
                                    (props.filterValueContratos?.length ?? []) >
                                    1
                                        ? "s"
                                        : ""
                                }?`,
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    ExcluirContratosCampanhaController(
                                        props.filterValueContratos as any[]
                                    ).then(() => {
                                        props.ListarContratosDistribuidosPorGrupo.execute();
                                    });
                                }
                            })
                        }
                    >
                        <FontAwesomeIcon icon={faFilter} />
                    </button>
                </OverlayTrigger>
            ),
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            headerFormatter: () => (
                <OverlayTrigger
                    overlay={
                        <Tooltip id="ver-info-tooltip">
                            Excluir Contratos Selecionados
                        </Tooltip>
                    }
                >
                    <button
                        className="btn btn-danger mb-4 mt-0"
                        onClick={() =>
                            Swal.fire({
                                title: `Deseja descartar ${
                                    props.lstSelecionadosDistribuidos?.Contratos
                                        .length ?? 0
                                } contrato${
                                    (props.lstSelecionadosDistribuidos
                                        ?.Contratos.length ?? []) > 1
                                        ? "s"
                                        : ""
                                }?`,
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    props.handleExcluirContratosEmMassa();
                                }
                            })
                        }
                        disabled={
                            props.ExcluirContratosEmMassaLoading ||
                            !props.lstSelecionadosDistribuidos?.Contratos.length
                        }
                    >
                        {props.ExcluirContratosEmMassaLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon icon={faTrash} />
                        )}
                    </button>
                </OverlayTrigger>
            ),
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <>
                    {
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="remover-tooltip">
                                    Editar classificação
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-icon btn-outline-primary"
                                onClick={() => {
                                    props.setModal({
                                        Component: () => (
                                            <UnForm
                                                handleSubmit={(formData) => {
                                                    props.handleSubmitClassificacao(
                                                        formData.ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA,
                                                        row.ID_CHAVE_ERP
                                                    );
                                                }}
                                            >
                                                <UnForm.LazySelect
                                                    label="Classificação"
                                                    name="ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA"
                                                    controller={
                                                        ListarClassificacaoCobrancaController
                                                    }
                                                    getDS={(ca) =>
                                                        ca.DS_CASO_COBRANCA_CLASSIFICACAO_COBRANCA
                                                    }
                                                    getKeyValue={(p) =>
                                                        p.ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA
                                                    }
                                                    registerOptions={{
                                                        required:
                                                            "Insira a Classificação",
                                                        valueAsNumber: true,
                                                    }}
                                                    className="form-control mb-2"
                                                />
                                                <button className="btn btn-outline-success w-100 mt-3">
                                                    Editar
                                                </button>
                                            </UnForm>
                                        ),
                                        headerComponent: "Editar classificação",
                                        noFooter: true,
                                        size: "lg",
                                        scrollable: true,
                                    });
                                    props.setShow(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </button>
                        </OverlayTrigger>
                    }
                </>
            ),
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex g-2 p-2">
                    <div>
                        {
                            //row.DS_RESULTADO_CONTATO !== "Contato Efetivo" &&
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="remover-tooltip">
                                        Remover Contrato Associado
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-icon btn-outline-danger"
                                    onClick={() => {
                                        Swal.fire({
                                            title: `Deseja remover a associação do contrato de ${row.DS_CLIENTE}?`,
                                            icon: "info",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Sim!",
                                            showCancelButton: true,
                                            cancelButtonText:
                                                "<i class='la la-thumbs-down'></i> Não",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-success",
                                                cancelButton: "btn btn-default",
                                            },
                                        }).then((result) => {
                                            if (
                                                result.isConfirmed &&
                                                row.ID_GRUPO &&
                                                row.ID_CASO_COBRANCA_FILA_ATENDIMENTO
                                            ) {
                                                ExcluirContratosController(
                                                    row.ID_CASO_COBRANCA_FILA_ATENDIMENTO
                                                ).then(() => {
                                                    props.ListarContratosDistribuidos.execute();
                                                    props.ListarContratosDistribuidosPorGrupo.execute();
                                                    props.ListarContratosNaoDistribuidos.execute();
                                                    props.setlstSelecionados(
                                                        []
                                                    );
                                                });
                                            }
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faUserTimes} />
                                </button>
                            </OverlayTrigger>
                        }
                    </div>
                </div>
            ),
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex g-2 p-2">
                    <div>
                        {
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="remover-tooltip">
                                        Remover Classificação
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-icon btn-outline-danger"
                                    onClick={() => {
                                        Swal.fire({
                                            title: `Deseja remover a classificação?`,
                                            icon: "info",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Sim!",
                                            showCancelButton: true,
                                            cancelButtonText:
                                                "<i class='la la-thumbs-down'></i> Não",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-success",
                                                cancelButton: "btn btn-default",
                                            },
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                RemoverClassificacaoManualController(
                                                    row.ID_CHAVE_ERP
                                                ).then(() => {
                                                    props.ListarContratosDistribuidos.execute();
                                                    props.ListarContratosDistribuidosPorGrupo.execute();
                                                    props.ListarContratosNaoDistribuidos.execute();
                                                    props.setlstSelecionados(
                                                        []
                                                    );
                                                });
                                            }
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faEraser} />
                                </button>
                            </OverlayTrigger>
                        }
                    </div>
                </div>
            ),
        },
    ];

    const expandRowManualCliente: ExpandRowProps<IListaGrupoContrato> = {
        onlyOneExpanding: true,
        renderer: (row) => (
            <>
                {props.lstContratosDistribuidosPorGrupo ? (
                    <>
                        <Table
                            headerClasses="bg-white"
                            columns={tableColumns}
                            data={row.Contratos.filter(
                                (contratos) =>
                                    contratos.FL_ALTERACAO_MANUAL === true
                            )}
                            keyField="ID_CASO_COBRANCA_FILA_ATENDIMENTO"
                            classes="v-middle-cells"
                            loading={props.ListarContratosDistribuidos.loading}
                            noDataIndication={
                                <div className="text-center text-black-50">
                                    Nenhum contrato distribuído encontrado
                                </div>
                            }
                            striped={true}
                            bordered={true}
                            noSearch={true}
                            filter={filterFactory({
                                afterFilter: (newResult, newFilters) => {
                                    props.filterValueContratos = newResult;
                                },
                            })}
                        />
                    </>
                ) : (
                    props.ListarContratosDistribuidos.loading && (
                        <SpinnerComponent />
                    )
                )}
            </>
        ),
    };
    const tableColumnsDeColunasPorGrupo: Array<
        ColumnDescription<IListaGrupoContrato>
    > = [
        {
            headerAlign: "center",
            dataField: "ID_GRUPO",
            text: "ID",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "DS_GRUPO",
            text: "Grupo",
            align: "center",
        },
        {
            headerAlign: "center",
            dataField: "QNT_CONTRATOS",
            text: "Quantidade de Contratos",
            align: "center",
            formatter: (_, row) => (
                <>
                    {
                        row.Contratos.filter(
                            (contrato) => contrato.FL_ALTERACAO_MANUAL === true
                        ).length
                    }
                </>
            ),
        },
        {
            headerAlign: "center",
            dataField: "VALOR_TOTAL",
            text: "Valor Total",
            align: "center",
            formatter: (_, row) => {
                const somaValorTotal = row.Contratos.filter(
                    (contrato) => contrato.FL_ALTERACAO_MANUAL === false
                ).reduce(
                    (total, contrato) => total + contrato.VL_PARCELAS_EM_ABERTO,
                    0
                );

                return formatMoneyReais(somaValorTotal);
            },
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex d-flex flex-row-reverse g-2 p-2">
                    <div>
                        {
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="remover-tooltip">
                                        Remover Grupo Associado
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-icon btn-outline-danger"
                                    onClick={() => {
                                        Swal.fire({
                                            title: `Deseja remover a associação dos contratos do grupo ${row.DS_GRUPO}?`,
                                            icon: "info",
                                            buttonsStyling: false,
                                            confirmButtonText:
                                                "<i class='la la-check'></i> Sim!",
                                            showCancelButton: true,
                                            cancelButtonText:
                                                "<i class='la la-thumbs-down'></i> Não",
                                            customClass: {
                                                confirmButton:
                                                    "btn btn-outline-success",
                                                cancelButton: "btn btn-default",
                                            },
                                        }).then((result) => {
                                            if (
                                                result.isConfirmed &&
                                                row.ID_GRUPO
                                            ) {
                                                ExcluirContratosPorGrupoController(
                                                    row.ID_GRUPO
                                                ).then(() => {
                                                    props.ListarContratosDistribuidos.execute();
                                                    props.ListarContratosDistribuidosPorGrupo.execute();
                                                    props.ListarContratosNaoDistribuidos.execute();
                                                    props.setlstSelecionados(
                                                        []
                                                    );
                                                });
                                            }
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTrash} size="lg" />
                                </button>
                            </OverlayTrigger>
                        }
                    </div>
                </div>
            ),
        },
    ];

    return (
        <Table
            columns={tableColumnsDeColunasPorGrupo}
            data={props.lstContratosDistribuidosPorGrupo ?? []}
            expandRow={expandRowManualCliente}
            keyField="ID_GRUPO"
            classes="v-middle-cells"
            loading={props.ListarContratosDistribuidosPorGrupo.loading}
            noDataIndication={
                <div className="text-center text-black-50">
                    Nenhum contrato distribuído encontrado
                </div>
            }
            striped={true}
            bordered={true}
        />
    );
}

export default TableManualCliente;
